import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'

import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { CreateRegisterAction } from '../../../redux/actions/user'
import * as types from '../../../redux/constantes/user'

import { ContainerContent, ContainerTemplate } from '../../../components/Containers'
import { MessageBoxError, MessageBoxSuccess } from '../../../components/MessageBox'
import { InputUser } from '../../../components/User/InputUser'
import { ButtonSend } from '../../../components/ButtonSend'
import { Header } from '../../../components/User/Header'
import { Title } from '../../../components/User/Title'
import { InputPhone } from '../../../components/User/InputPhone'
import { ModalConfirmation } from '../../../components/User/ModalConfirmation'
import { LGPD } from '../../../components/User/LGPD'
import { WrapperButtonsModal } from '../../../components/User/ModalConfirmation/style'
import { nameIsValid } from '../../../functions/nameIsValid'
import { cpfIsValid } from '../../../functions/cpfIsValid'
import { emailIsValid } from '../../../functions/emailIsValid'
import { phoneIsValid } from '../../../functions/phoneIsValid'
import { fullValidations } from '../../../functions/fullValidations'

export const TemplateRegister: React.FC = () => {
  const { loading, success, error } = useSelector((state: RootStateOrAny) => state.createUser)
  const dispatch = useDispatch()
  const history = useHistory()

  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [name, setName] = useState('')
  const [cpf, setCpf] = useState('')
  const [cnpj, setCnpj] = useState('')

  const [isVerify, setIsVerify] = useState(false)
  const [validateCpf, setValidateCpf] = useState(true)
  const [validateName, setValidateName] = useState(true)
  const [validateEmail, setValidateEmail] = useState(true)
  const [validatePhone, setValidatePhone] = useState(true)
  const [disableAllInputs, setDisableAllInputs] = useState(false)

  const [preConfirmed, setPreConfirmed] = useState(false)

  const validateAcceptedTerms = () => {
    setValidateName(nameIsValid(name))
    setValidateCpf(cpfIsValid(cpf))
    setValidateEmail(emailIsValid(email))
    setValidatePhone(phoneIsValid(phone))
    setIsVerify(true)
  }

  const onSubmit = () => {
    setPreConfirmed(false)
    const phoneFormate = `+55 ${phone}`
    dispatch(CreateRegisterAction(name, cpf, email, phoneFormate, cnpj))
  }

  useEffect(() => {
    if (success) {
      setDisableAllInputs(true)
      setIsVerify(false)
      setTimeout(() => {
        dispatch({ type: types.CREATE_REGISTER_RESET })
        history.push('/cadastro-realizado')
      }, 5000)
    }
    if (error) {
      setTimeout(() => {
        dispatch({ type: types.CREATE_REGISTER_RESET })
      }, 5000)
    }
  }, [success, error])

  return (
    <ContainerTemplate>
      <Header />
      <ContainerContent>
        <Title text="Insira aqui seus dados" />
        <InputUser
          label={`* Nome Completo ${!validateName ? '(Campo obrigatório esta em branco)' : ''}`}
          onBlur={() => setValidateName(nameIsValid(name))}
          onChange={e => setName(e.target.value)}
          placeholder="exemplo: Augusto Ferreira da Silva"
          value={name}
          isValidate={validateName}
          disabled={disableAllInputs}
        />
        <InputUser
          useMask={true}
          layoutMask="999.999.999-99"
          label={`* CPF ${!validateCpf ? '(Campo obrigatório esta em branco ou incorreto)' : ''}`}
          onBlur={() => setValidateCpf(cpfIsValid(cpf))}
          onChange={e => setCpf(e.target.value)}
          placeholder="exemplo: 123.456.789-00"
          value={cpf}
          isValidate={validateCpf}
          disabled={disableAllInputs}
        />
        <InputUser
          label={`* E-mail ${!validateEmail ? '(Campo obrigatório esta em branco ou incorreto)' : ''}`}
          onBlur={() => setValidateEmail(emailIsValid(email))}
          onChange={e => setEmail(e.target.value)}
          placeholder="exemplo: email@gmail.com"
          value={email}
          isValidate={validateEmail}
          disabled={disableAllInputs}
        />
        <InputPhone
          label={`* Celular (DDD + número) ${!validatePhone ? '(Campo obrigatório esta em branco ou incorreto)' : ''}`}
          onBlur={() => setValidatePhone(phoneIsValid(phone))}
          onChange={e => setPhone(e.target.value)}
          placeholder="exemplo: (11) 98888-8888"
          value={phone}
          isValidate={validatePhone}
          disabled={disableAllInputs}
        />
        <InputUser
          useMask={true}
          layoutMask="99.999.999/9999-99"
          label="CNPJ (Caso possua)"
          onChange={e => setCnpj(e.target.value)}
          placeholder="exemplo: 99.999.999/9999-99"
          value={cnpj}
          disabled={disableAllInputs}
        />
        <LGPD validateAcceptedTerms={validateAcceptedTerms} isVerify={isVerify} setIsVerify={setIsVerify} />
        {!loading ? (
          <WrapperButtonsModal>
            <ButtonSend
              nameButton="Enviar"
              disabled={fullValidations(validateName, validateCpf, validateEmail, validatePhone, isVerify)}
              onClick={() => setPreConfirmed(true)}
            />
          </WrapperButtonsModal>
        ) : (
          <ButtonSend nameButton="Aguarde..." disabled={true} />
        )}
        {preConfirmed && (
          <ModalConfirmation
            onSubmit={onSubmit}
            setPreConfirmed={setPreConfirmed}
            email={email}
            phone={phone}
            name={name}
            cpf={cpf}
            cnpj={cnpj}
          />
        )}

        {success && <MessageBoxSuccess>{success}</MessageBoxSuccess>}
        {error && <MessageBoxError>{error}</MessageBoxError>}
      </ContainerContent>
    </ContainerTemplate>
  )
}
